import GiftGoldIcon from '@/shared/assets/gift-gold.svg';
import FreespinIcon from '@/shared/assets/freespin-gold.svg';
import DepositGoldIcon from '@/shared/assets/deposit-gold.svg';

type BonusTypeIconProps = {
  type: string;
};

export const BonusTypeIcon = ({ type }: BonusTypeIconProps) => {
  switch (type) {
    case 'nondep':
      return <GiftGoldIcon />;
    case 'freespin':
      return <FreespinIcon />;
    case 'dep':
      return <DepositGoldIcon />;
    default:
      return null;
  }
};
